import { render, staticRenderFns } from "./assessor-view.vue?vue&type=template&id=34db466e"
import script from "./assessor-view.vue?vue&type=script&lang=js"
export * from "./assessor-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports